import { Module } from 'vuex-smart-module';
import MoneyPlanFact from './modules/money-plan-fact';
import ReportsSalesActions from './actions';
import ReportsSalesGetters from './getters';
import ReportsSalesMutations from './mutations';
import ReportsSalesState from './state';

export default new Module({
  state: ReportsSalesState,
  mutations: ReportsSalesMutations,
  actions: ReportsSalesActions,
  getters: ReportsSalesGetters,
  modules: {
    money_plan_fact: MoneyPlanFact,
  },
});
